export const roles = [
  { text: "Auto Wrecker", value: "auto_wrecker" },
  { text: "Local Collector", value: "local_collector" },
  { text: "Admin", value: "admin" },
];

export const ADMIN = "admin";
export const AUTO_WRECKER = "auto_wrecker";
export const LOCAL_COLLECTOR = "local_collector";

export const provinces = [
  "AB",
  "BC",
  "MB",
  "NB",
  "NL",
  "NT",
  "NS",
  "NU",
  "ON",
  "PE",
  "QC",
  "SK",
  "YT",
];
export const MONTHS = [
  { text: "Jan", value: "1" },
  { text: "Feb", value: "2" },
  { text: "Mar", value: "3" },
  { text: "Apr", value: "4" },
  { text: "May", value: "5" },
  { text: "June", value: "6" },
  { text: "July", value: "7" },
  { text: "Aug", value: "8" },
  { text: "Sep", value: "9" },
  { text: "Oct", value: "10" },
  { text: "Nov", value: "11" },
  { text: "Dec", value: "12" },
];
export const DOWNLOAD_LINK_CUTOFF = 22;
export const CHECK_IN_SHEET_HEADERS = [
  {
    text: "Item",
    value: "code",
    width: "auto",
    fixed: true,
    type: "text",
  },
  {
    text: "Cost Per Item",
    value: "cost",
    width: "150px",
    fixed: true,
    type: "text",
    prefix: "$",
    classes: "font-weight-black",
    filterable: false,
  },
  {
    text: "Quantity",
    value: "quantity",
    width: "120px",
    fixed: true,
    type: "number",
    filterable: false,
  },
  {
    text: "Subtotal",
    value: "subtotal",
    width: "auto",
    fixed: true,
    type: "text",
    prefix: "$",
    classes: "font-weight-black",
    filterable: false,
  },
  { text: "", value: "actions", width: "auto", fixed: true, filterable: false },
];
export const ITEM = { code: "", cost: 0, quantity: 0 };
export const ADMIN_MENU = [
  { title: "Search", name: "search", isExact: true },
  { title: "Catalytic Converters", name: "catalytic-converters" },
  { title: "Vehicles", name: "vehicles" },
  { title: "Users", name: "users" },
  { title: "User Logs", name: "user-logs"},
  { title: "Check-in Sheets", name: "check-in-sheets"},
];

export const NON_ADMIN_MENU = [
  { title: "Search", name: "search", isExact: true },
  { title: "Check-in Sheets", name: "check-in-sheets"}
];